import CaretRightIcon from "public/next-public/common/icons/caret-solid-right.svg";
import { ReactElement, RefObject, useMemo } from "react";
import style from "./listMenuItem.module.scss";

export default function ListMenuItem({
  children,
  id,
  iconDecorationPrefix,
  descriptionSuffix,
  linkTo,
  subMenu,
  navigateToSubMenuCallback,
  customClickCallback,
  className,
}: ListMenuItemProps) {
  function handleSubMenuClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
    event.preventDefault();
    event.stopPropagation();
    if (navigateToSubMenuCallback && subMenu) {
      navigateToSubMenuCallback.current(subMenu);
    }
  }

  const itemContent = useMemo(() => {
    return (
      <>
        <span className={style.itemContentLeftAlign}>
          {iconDecorationPrefix && <span className={style.menuIcon}>{iconDecorationPrefix}</span>}
          <div className={style.listMenuText}>
            {children}
            {descriptionSuffix && <span className={style.itemDescription}>{descriptionSuffix}</span>}
          </div>
        </span>
        <span className={style.itemContentRightAlign}>
          {subMenu && <CaretRightIcon className={`${style.menuIcon} ${style.caret}`} fill="currentColor" />}
        </span>
      </>
    );
  }, [children, descriptionSuffix, iconDecorationPrefix, subMenu]);

  const containerClassName = className ? `${style.listMenuItemContainer} ${className}` : style.listMenuItemContainer;

  return subMenu ? (
    <div
      id={id}
      className={containerClassName}
      onClick={(event) => {
        if (subMenu) handleSubMenuClick(event);
        if (customClickCallback) customClickCallback();
      }}
    >
      {itemContent}
    </div>
  ) : (
    <a
      href={linkTo}
      id={id}
      className={containerClassName}
      onClick={(event) => {
        if (customClickCallback) customClickCallback();
      }}
    >
      {itemContent}
    </a>
  );
}

export type ListMenuItemProps = {
  children: React.ReactNode;
  id: string;
  iconDecorationPrefix?: React.ReactNode;
  descriptionSuffix?: string;
  linkTo?: string;
  subMenu?: ReactElement | undefined;
  navigateToSubMenuCallback?: RefObject<(newActiveMenu: ReactElement | null) => void>;
  customClickCallback?: () => void;
  className?: string;
};
